import {
  PUBLIC_BLOG_SLUG,
  PUBLIC_BLOG_SLUG_EN,
  PUBLIC_BLOG_SLUG_FI,
  PUBLIC_BLOG_SLUG_NB,
  PUBLIC_BLOG_SLUG_SV,
  PUBLIC_BLOG_SLUG_DA,
  PUBLIC_BLOG_SLUG_ES
} from '$env/static/public';

export const getBlogSlug = (locale: string) => {
  switch (locale) {
    case 'en': return PUBLIC_BLOG_SLUG_EN;
    case 'fi': return PUBLIC_BLOG_SLUG_FI;
    case 'no':
    case 'nb': return PUBLIC_BLOG_SLUG_NB;
    case 'sv': return PUBLIC_BLOG_SLUG_SV;
    case 'da': return PUBLIC_BLOG_SLUG_DA;
    case 'es': return PUBLIC_BLOG_SLUG_ES;
    default: return PUBLIC_BLOG_SLUG;
  }
};